export function toWildcardSearch(search: string): string {
	if (search.trim() === '') {
		return search;
	}
	return search.trim().split(/\s+/)
		.map((part) => `${part}*`)
		.join(' ');
}
